import React, { useRef, useState } from 'react';
import { usePDFImport } from '../hooks/usePDFImport';

export default function PDFImporter({ tipo, onImport }) {
  const inputRef = useRef(null);
  const { importarPDF, loading, error } = usePDFImport();
  const [fileName, setFileName] = useState(null);
  const [success, setSuccess] = useState(false);

  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file || file.type !== 'application/pdf') return;
    setFileName(file.name);
    setSuccess(false);
    try {
      const dados = await importarPDF(file, tipo);
      onImport(dados);
      setSuccess(true);
    } catch (err) {
      console.error(err);
    }
    // Reset input
    e.target.value = '';
  }

  const label = tipo === 'dieta' ? 'plano alimentar' : tipo === 'exame' ? 'pedido de exame' : 'planilha de treino';

  return (
    <div style={{
      border: '1.5px dashed var(--divider)',
      borderRadius: 'var(--r-card)',
      padding: '20px',
      background: 'rgba(213,202,178,0.08)',
      marginBottom: '20px',
      transition: 'border-color 0.2s',
    }}>
      <style>{`
        .pdf-import-btn { padding:9px 20px; background:var(--accent); color:var(--btn-text); border:none; border-radius:var(--r-btn); font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; cursor:pointer; font-family:'Inter',sans-serif; transition:background 0.2s; }
        .pdf-import-btn:hover { background:var(--accent-hover); }
        .pdf-import-btn:disabled { opacity:0.6; cursor:not-allowed; }
      `}</style>

      <div style={{ display:'flex', alignItems:'center', gap:'14px', flexWrap:'wrap' }}>
        <div style={{ flex:1, minWidth:'160px' }}>
          <div style={{ fontSize:'13px', fontWeight:600, color:'var(--text)', marginBottom:'3px' }}>
            Importar via PDF
          </div>
          <div style={{ fontSize:'12px', color:'var(--text-2)', lineHeight:1.5 }}>
            Faça upload do {label} em PDF e a IA preenche os campos automaticamente.
            {tipo === 'dieta' && ' Também aceita um PDF só com as orientações — a IA preenche apenas o campo "Orientações", sem mexer no resto.'}
          </div>
        </div>

        <input
          ref={inputRef}
          type="file"
          accept="application/pdf"
          onChange={handleFile}
          style={{ display:'none' }}
        />

        <button
          className="pdf-import-btn"
          onClick={() => inputRef.current?.click()}
          disabled={loading}
        >
          {loading ? (
            <span style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ display:'inline-block', width:'12px', height:'12px', border:'2px solid rgba(255,246,237,0.3)', borderTopColor:'var(--btn-text)', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
              Lendo PDF...
            </span>
          ) : (
            '↑ Importar PDF'
          )}
        </button>
      </div>

      {loading && (
        <div style={{ marginTop:'12px', fontSize:'12px', color:'var(--accent)', display:'flex', alignItems:'center', gap:'6px' }}>
          <span style={{ display:'inline-block', width:'10px', height:'10px', border:'1.5px solid rgba(137,91,64,0.3)', borderTopColor:'var(--accent)', borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
          A IA está lendo {fileName && `"${fileName}"`} e extraindo as informações...
        </div>
      )}

      {success && !loading && (
        <div style={{ marginTop:'12px', fontSize:'12px', color:'#2E7D32', display:'flex', alignItems:'center', gap:'6px' }}>
          ✓ PDF importado com sucesso! Revise os campos abaixo antes de salvar.
        </div>
      )}

      {error && !loading && (
        <div style={{ marginTop:'12px', fontSize:'12px', color:'#C62828' }}>
          ✗ Erro ao ler o PDF: {error}. Tente novamente ou preencha manualmente.
        </div>
      )}

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
